<template>
    <div>
        <ManageCase
            :chkViewMain="chkViewMain"
            @case="ViewCase()"
            @homePage="getHome()"
            @pageToFoot="getPages"
            v-if="
                (chkViewMain === 'managecase' || chkViewMain === '') &&
                (team_name === 'ONSITE' ||
                    team_name === 'SVC' ||
                    team_name === 'INVENTORY' ||
                    team_name === 'NONHP')
            "
        />
        <ViewAttachInformation class="no-pd" v-if="chkViewMain === ''" />

        <div v-if="chkViewMain === ''" class="mar-t-15">
            <v-row class="mt-5">
                <v-progress-linear
                    v-if="data_btn_menu.length === 0"
                    indeterminate
                    color="cyan"
                ></v-progress-linear>
                <v-col
                    class="text-center"
                    cols="4"
                    v-for="(row, index) in data_btn_menu"
                    :key="index"
                >
                    <v-badge
                        avatar
                        bordered
                        overlap
                        v-if="row.count > 0 || row.count === 'return'"
                    >
                        <template v-slot:badge>
                            <v-avatar
                                :color="
                                    row.status_date == 'yesterday'
                                        ? 'red lighten-1'
                                        : 'teal'
                                "
                                v-if="row.count != 'return'"
                            >
                                {{ row.count }}
                            </v-avatar>
                            <v-avatar
                                :color="
                                    row.status_date == 'notapprove'
                                        ? 'red lighten-1'
                                        : 'amber darken-1'
                                "
                                v-if="row.count == 'return'"
                            >
                                <v-icon>mdi-alert</v-icon>
                            </v-avatar>
                        </template>

                        <v-avatar
                            :class="
                                row.status === 'active'
                                    ? 'fix-avatar-2 cur-p'
                                    : 'fix-avatar-3 cur-p'
                            "
                            color="blue lighten-5"
                            @click="change_menu(row.ce_menu_title, row.status)"
                        >
                            <v-icon large dark class="btn-menu-9">
                                {{ row.ce_menu_icon }} // {{ row.status_date }}
                            </v-icon>
                        </v-avatar>
                    </v-badge>

                    <v-avatar
                        v-if="row.count === 0"
                        :class="
                            row.status === 'active'
                                ? 'fix-avatar-2 cur-p'
                                : 'fix-avatar-3 cur-p'
                        "
                        @click="change_menu(row.ce_menu_title, row.status)"
                        color="blue lighten-5"
                    >
                        <v-icon large dark class="btn-menu-9">
                            {{ row.ce_menu_icon }}
                        </v-icon>
                    </v-avatar>
                    <br />
                    <span class="fix-font-1">{{ row.ce_menu_title }}</span>
                </v-col>
            </v-row>
        </div>

        <Onsite
            @select_menu="chk_onsite()"
            v-if="
                chkViewMain === 'Onsite' ||
                chkViewMain === 'return' ||
                chkViewMain === 'complete'
            "
            :chkViewMain="chkViewMain"
            :status_onsite_at="status_onsite_at"
        />
        <ScheduleCase
            @select_menu="chk_onsite()"
            v-if="chkViewMain === 'ScheduleCase'"
            :data_ScheduleCase="data_ScheduleCase"
        />

        <ReceivePart v-if="chkViewMain === 'Receive Part'" />

        <Pending @homePage="getHome()" v-if="chkViewMain === 'Pending'" />

        <Performance v-if="chkViewMain === 'Performance'" />

        <ReturnDocument v-if="chkViewMain === 'Return Document'" />

        <ReturnPart v-if="chkViewMain === 'Return Part'" />

        <CaseOnsite v-if="chkViewMain === 'Schedule Case'" />

        <Mileage v-if="chkViewMain === 'Mileage'" />

        <OnsitePending v-if="chkViewMain === 'Zone Pending'" />

        <AssignToday v-if="chkViewMain == 'Assign Today'" />

        <Ot v-if="chkViewMain == 'OT'" />

        <h3 class="ml-4" v-if="chkViewMain === 'no-case-today'">
            No Case Onsite Today
        </h3>

        <h3 class="ml-4 red--text" v-if="chkViewMain === 'upload-img'">
            มีเคสนี้มีการข้ามอัพโหลดรูป.. กรุณาเข้าไปอัพโหลดรูปใน Menu Pending
            หัวข้อ UPLOAD IMG FAILED
        </h3>

        <Footer
            @homePage="getHome()"
            @pageToFoot="getPages"
            :chkViewMain="chkViewMain"
            :data_btn_menu="data_btn_menu"
            v-if="
                chkViewMain === 'managecase' ||
                chkViewMain === 'Onsite' ||
                chkViewMain === 'return' ||
                chkViewMain === 'ScheduleCase' ||
                chkViewMain === 'Pending' ||
                chkViewMain === 'Performance' ||
                chkViewMain === 'Return Document' ||
                chkViewMain === 'complete' ||
                chkViewMain === 'Return Part' ||
                chkViewMain === 'no-case-today' ||
                chkViewMain === 'Schedule Case' ||
                chkViewMain === 'Receive Part' ||
                chkViewMain === 'Mileage' ||
                chkViewMain === 'OT' ||
                chkViewMain === 'OnsitePending' ||
                chkViewMain === 'Mileage' ||
                chkViewMain === 'News' ||
                chkViewMain === 'Assign Today' ||
                chkViewMain === 'Zone Pending' ||
                chkViewMain === 'upload-img'
            "
        />
        <v-bottom-navigation height="25" fixed grow v-if="chkViewMain == ''">
            <v-icon
                small
                v-if="time_att.time_in != '' && time_att.time_in != null"
                color="teal"
                class="icon-fix"
                @click="get_page_timeatt()"
                >mdi-alarm-check</v-icon
            >
            <span
                class="ml-1 teal--text"
                @click="get_page_timeatt()"
                v-if="time_att.time_in != '' && time_att.time_in != null"
            >
                {{ time_att.time_in }}
            </span>
            <v-icon
                small
                v-if="time_att.time_in == '' || time_att.time_in == null"
                color="red"
                class="icon-fix"
                @click="get_page_timeatt()"
                >mdi-alarm-off</v-icon
            >
            <span
                @click="get_page_timeatt()"
                class="ml-1 red--text"
                v-if="time_att.time_in == '' || time_att.time_in == null"
            >
                ไม่ได้ลงเวลาเข้างาน
            </span>

            <span
                style="color: #fff"
                class="ml-3 mr-3"
                v-if="time_att.time_in != ''"
                >.</span
            >

            <v-icon
                style="color: #546e7a"
                small
                v-if="time_att.device == 'pc' && time_att.time_in != ''"
                class="icon-fix"
                >mdi-desktop-mac</v-icon
            >
            <v-icon
                style="color: #546e7a"
                small
                v-if="time_att.device == 'mobile' && time_att.time_in != ''"
                class="icon-fix"
                >mdi-cellphone-iphone</v-icon
            >
            <span
                style="color: #546e7a"
                v-if="time_att.time_in != ''"
                class="ml-1"
            >
                {{ time_att.branch }}
            </span>

            <span
                style="color: #fff"
                class="ml-3 mr-3"
                v-if="time_att.time_in != ''"
                >.</span
            >

            <v-icon
                style="color: #3d57ff"
                small
                class="icon-fix"
                @click="get_page_covid()"
                >mdi-google-maps</v-icon
            >
            <span style="color: #3d57ff" class="ml-1" @click="get_page_covid()">
                check point
            </span>
        </v-bottom-navigation>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

import Footer from "./components/footer"
import ManageCase from "./components/ManageCase"
import Onsite from "./components/Onsite"
import ScheduleCase from "./components/ScheduleCase"
import Pending from "./components/Pending"
import ViewAttachInformation from "../Project/components/ViewAnnounce"
import Performance from "./components/Performance"
import ReturnDocument from "./components/ReturnDocument"
import ReturnPart from "./components/ReturnPart"
import CaseOnsite from "../../pages/Project/Odm/CaseOnsite"
import Mileage from "./components/Mileage"
import ReceivePart from "./components/ReceivePart"
import OnsitePending from "./components/OnsitePending"
import AssignToday from "./components/AssignToday"
import Ot from "./components/Ot"
import DirectionsRenderer from "../../test/components/DirectionsRenderer.js"

import firebaseApp from "../../firebase"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        if (this.$route.params.menu != undefined) {
            if (this.$route.params.menu === "Return-Document") {
                this.chkViewMain = "Return Document"
            } else if (this.$route.params.menu === "Return-Part") {
                this.chkViewMain = "Return Part"
            }
        }
        // this.chk_url()
        this.get_data()
    },
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["chk_token"]),
    },
    components: {
        Footer,
        ManageCase,
        ViewAttachInformation,
        Onsite,
        ScheduleCase,
        Pending,
        Performance,
        ReturnDocument,
        ReturnPart,
        CaseOnsite,
        Mileage,
        ReceivePart,
        DirectionsRenderer,
        OnsitePending,
        AssignToday,
        Ot,
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutateToken"]),

        async get_data() {
            this.get_emp_id()
            this.func_chk_tk()
            await axios
                .get(url + "engineer/menu/", this.tk)
                .then((response) => {
                    if (response.data.status == "token_expired") {
                        this.logout()
                    } else {
                        this.data_btn_menu = response.data.menu
                        this.time_att.device = response.data.time_att.device
                        this.time_att.branch = response.data.time_att.branch
                        this.time_att.time_in = response.data.time_att.time_in
                        this.get_num_pending()
                    }
                })
        },
        ViewCase() {
            this.chkViewMain = "managecase"
        },
        getHome() {
            this.func_chk_tk()
            this.get_data()
            this.chkViewMain = ""
        },
        async change_menu(menu, status) {
            this.func_chk_tk()
            status === "inactive" ? (menu = "") : (menu = menu)
            if (menu != "Return Document" || menu != "Return Part") {
                this.$router.push("/Onsite/Main/").catch((err) => {
                    // console.log(err)
                })
            }

            if (menu === "Onsite") {
                this.dialog_loading = true
                await axios
                    .get(url + "engineer/check-scheduled", this.tk)
                    .then((response) => {
                        if (
                            response.data.status === "Onsite" ||
                            response.data.status === "return"
                        ) {
                            this.status_onsite_at = response.data.detail
                            this.chkViewMain = response.data.status
                        } else if (response.data.status === "schedule") {
                            this.data_ScheduleCase = response.data.data
                            this.chkViewMain = "ScheduleCase"
                        } else {
                            this.chkViewMain = response.data.status
                        }
                        this.dialog_loading = false
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else {
                this.chkViewMain = menu
            }
        },
        chk_onsite() {
            let menu = "Onsite"
            this.change_menu(menu)
        },
        getPages(result) {
            this.change_menu(result)
            // this.chkViewMain = result
        },
        get_lan_lng() {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.gps.lat = position.coords.latitude
                    this.gps.lng = position.coords.longitude

                    this.update_gps_sv()
                },
                (error) => {
                    console.log(error.message)
                }
            )
        },
        async get_emp_id() {
            await axios
                .get(url + "account-detail", this.tk)
                .then((response) => {
                    this.emp_id = response.data.emp_id
                    this.get_lan_lng()
                })
        },
        async update_gps_sv() {
            await axios
                .post(url + "engineer/save-location", this.gps, this.tk)
                .then((response) => {
                    this.update_gps()
                })
        },
        update_gps() {
            let database = firebaseApp.database()
            let userID = this.emp_id
            let ref = firebaseApp.database().ref("gpstracking/")
            let name = this.role_name

            let postData = {
                lat: this.gps.lat,
                lng: this.gps.lng,
                name: this.fullname,
                role_type: this.role_type,
                lastUpd: new Date().toLocaleString(),
            }
            let updates = {}
            updates["/gpstracking/" + userID + "/"] = postData

            return firebaseApp.database().ref().update(updates)
        },
        func_chk_tk() {
            // let date_a = new Date()
            // let date = new Date(localStorage.storagetime)
            // let seconds = (date_a - date) / 1000
            // if (seconds > 0) {
            //     this.mutateToken()
            // }
            let date_a = new Date()
            let date = new Date(localStorage.storagetime)
            date.setHours(date.getHours() + 2)

            let seconds = (date_a - date) / 1000
            if (seconds > 0) {
                this.mutateToken()
            } else {
                date_a.setHours(date_a.getHours() + 2)
                localStorage.setItem("storagetime", date_a)
            }
        },
        async chk_url() {
            let send = {
                url: this.$route.path,
            }
            await axios
                .post(url + "check-auth", send, this.tk)
                .then((response) => {
                    if (response.data.status == "error") {
                        this.$root.$router.push({
                            path: "/404",
                        })
                    } else {
                        this.get_data()
                    }
                })
                .catch((error) => {
                    console.log(error, 'error')
                })
        },
        async get_num_pending() {
            await axios
                .get(url + "engineer/pending/tl-get-num-pending", this.tk)
                .then((response) => {
                    this.count_pending = response.data.num_cases
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        get_page_covid() {
            let url_map = "/covid/survey"
            window.open(url_map, "_blank")
        },
        // get_page_timeatt() {
        //     let routeData = this.$router.resolve({
        //         path: "/Timeatt",
        //         query: { q: this.emp_id },
        //     })

        //     window.open(routeData.href, "_blank")
        // },
        get_page_timeatt() {
            if (
                this.team_name != "ONSITE" ||
                (this.team_name == "ONSITE" &&
                    (this.role_name == "WFH" || this.role_name == "TL"))
            ) {
                let routeData = this.$router.resolve({
                    path: "/Timeatt",
                    query: { q: this.emp_id },
                })
                // let url_map = "/Timeatt"
                window.open(routeData.href, "_blank")
            }
        },
        logout() {
            localStorage.removeItem("storagetime")
            localStorage.removeItem("fullname")
            localStorage.removeItem("token")
            localStorage.removeItem("team_name")
            localStorage.removeItem("emp_img")
            localStorage.removeItem("themes")
            localStorage.removeItem("chk_newuser")
            localStorage.removeItem("role_type")
            localStorage.removeItem("travel_mode")

            this.mutateToken()
        },
    },
    data() {
        return {
            dialog_loading: false,
            time_att: {
                device: "",
                branch: "",
                time_in: "",
            },
            chkViewMain: "",
            data_ScheduleCase: [],
            data_btn_menu: [],
            status_onsite_at: null,
            team_name: localStorage.team_name,
            role_name: localStorage.role_name,
            role_type: localStorage.role_type,
            fullname: localStorage.fullname,
            tk: "",
            gps: {
                lat: "",
                lng: "",
            },
            emp_id: null,

            count_pending: 0,
        }
    },
}
</script>
<style scoped>
.fix-avatar-2 {
    border-radius: 30% !important;
    height: 65px !important;
    width: 65px !important;
    background: linear-gradient(
        to bottom right,
        rgb(40, 79, 151),
        rgb(10, 138, 116)
    );
}

.fix-avatar-2:hover {
    border-radius: 25% !important;
    height: 65px !important;
    width: 65px !important;
    background: linear-gradient(
        to bottom right,
        rgb(0, 79, 226),
        rgb(5, 218, 182)
    );
}
.fix-avatar-3 {
    border-radius: 30% !important;
    height: 65px !important;
    width: 65px !important;
    background: linear-gradient(
        to bottom right,
        rgb(230, 228, 228),
        rgb(147, 158, 158)
    );
}

.btn-menu-9 {
    color: white !important;
    font-size: 45px !important;
}
.mar-t-18 {
    margin-top: -18px;
}

/* sdf */
swal-overlay {
    background-color: rgba(82, 142, 170, 0.45);
}

.fix-font-1 {
    font-size: 11px !important;
}

.icon-fix {
    margin-top: -2px !important;
}
</style>
